import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FormSelect = ({
  section, type, assessments, setAssessments, formDisabled,
}) => {
  const handleChange = (code) => {
    let index = assessments.findIndex((assessment) => assessment.code === code);

    const assessmentList = assessments.slice();
    assessmentList[index].isChecked = !assessmentList[index].isChecked;

    if (code === 'registration') {
      if (assessmentList[index].isChecked) {
        index = assessments.findIndex((assessment) => assessment.code === 'nutriscreen');

        assessmentList[index].isChecked = true;
        assessmentList[index].isDisabled = true;
      } else {
        index = assessments.findIndex((assessment) => assessment.code === 'nutriscreen');

        assessmentList[index].isChecked = false;
        assessmentList[index].isDisabled = false;
      }
    }
    setAssessments(assessmentList);
  };

  if (assessments.filter((assessment) => assessment.type === type).length === 0) {
    return null;
  }

  return (
    <Form>
      <hr />
      <h3>{section}</h3>
      {assessments
        .filter((assessment) => assessment.type === type)
        .map((assessment) => (
          <Form.Check
            type="checkbox"
            label={assessment.name}
            checked={assessment.isChecked}
            disabled={assessment.isDisabled || formDisabled}
            onChange={() => handleChange(assessment.code)}
            key={assessment.code}
          />
        ))}
    </Form>
  );
};

FormSelect.propTypes = {
  section: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  assessments: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      isChecked: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  setAssessments: PropTypes.func.isRequired,
  formDisabled: PropTypes.bool.isRequired,
};

export default FormSelect;
